module.exports = __webpack_public_path__ + "static/img/ai.2cc55a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ai.png
// module id = 88Z3
// module chunks = 7